import * as React from 'react';
import './logo.module.scss';
import { Logo } from '../../../commonv2/components/navigation/LikesLogo';
import { ClickableProps, StylableProps } from '../../../commonv3/types/props';
import classNames from 'classnames';

type Props = StylableProps & ClickableProps;

// eslint-disable-next-line no-unused-vars
export const HeaderLogo = ({ className, onClick }: Props) => (
  <Logo
    id="likes-logo"
    styleName={classNames('header-logo', { clickable: onClick })}
    className={className}
    onClick={onClick}
  />
);
